var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefiSaver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 166,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.667 31.887c-1.431-1.821-4.122-1.909-5.759-.271l-28.099 28.099c-1.385 1.384-1.54 3.556-.558 5.25a35.167 35.167 0 010 35.252c-.982 1.694-.827 3.866.558 5.25l28.099 28.099c1.637 1.638 4.328 1.55 5.759-.272 23.353-29.731 23.353-71.676 0-101.407zM31.888 17.515c-1.822 1.43-1.91 4.121-.272 5.76l28.1 28.098c1.384 1.384 3.556 1.54 5.249.558a35.166 35.166 0 0135.253 0c1.694.982 3.865.826 5.25-.558l28.099-28.099c1.637-1.638 1.55-4.329-.272-5.76-29.731-23.352-71.676-23.352-101.407 0zm73.58 96.294c-1.385-1.384-3.556-1.54-5.25-.558a35.168 35.168 0 01-35.253 0c-1.694-.982-3.865-.826-5.25.558l-28.099 28.099c-1.637 1.638-1.55 4.329.272 5.759 29.73 23.353 71.676 23.353 101.407 0 1.822-1.43 1.909-4.121.272-5.759l-28.099-28.099zM51.931 64.964c.982-1.693.826-3.865-.558-5.25L23.274 31.617c-1.638-1.638-4.329-1.55-5.76.271-23.352 29.73-23.352 71.676 0 101.407 1.431 1.822 4.122 1.91 5.76.272l28.1-28.099c1.383-1.384 1.539-3.556.557-5.25a35.166 35.166 0 010-35.253z",
    fill: "#37B06F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefiSaver);
export default __webpack_public_path__ + "static/media/defi-saver.de4f3a4b899a22fe4bcd481e7048237a.svg";
export { ForwardRef as ReactComponent };